import styles from "./meetingschedule.module.scss";
import React, { useEffect, useState } from 'react';
import { meetingSDK } from "unifiedring-sdk";
import { DatePicker, Menu, Select } from 'antd';
import { Dropdown, Switch, Input, Modal } from "antd";
//import TextArea from "antd/lib/input/TextArea";
import moment from 'moment';
import { URRadio } from "../../../../shared/widgets/radiobox";
import { URInput } from "../../../../shared/widgets/input";
import { URButton } from "../../../../shared/widgets/button";
import { TIMEZONE } from '../../../../base/meetingService/timezone';
import _ from "lodash";
import { storeMeetingPage, storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import {
  calendarType,
  generatePassword, getMeetingId,
  getPersonalData, uuidv4
} from "../../../../base/meetingService/utils/meetingServices";
import { URCheckBox } from "../../../../shared/widgets/checkBoxForCall";
import { getEndDate, rRuleFrame } from "../../../../base/meetingService/rrule";
import { asrSearchLanguage, getTimeFormatAMPM, searchHandler, searchHighlight, toastInformation, userStatusColor, getMaxDurationFormat, getCurrentTime } from "../../../../base/callService/common";
import store from "../../../../context/store/store";
//import AddParticipant from "../addParticipant";
import FileUpload_MeetingCreation from "./fileUpload";
import { getMeetingLists, updateMeetingRead } from "../../../../base/meetingService/apiService";
import { useSelector } from "react-redux";
import SingleParticipantList from "../singleParticipantList";
import { meetingDetails } from "../../../../models/meetingModel";

import taskimg2 from "../../../../styles/images/participantaddicon.svg";
//import { Link } from "react-router-dom";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { profileDetails } from "../../../../models/model";
import { Types } from "../../../../context/action/action";
// type rruleState={
//   isRecurringEvent:boolean;
//   repeat_every:number;
//   value_disabled:boolean;
//   afteroccur:number;
//   occurOnDay:number;
//   occureon:number;
//   monthlyWeek:string;
//   monthlyDay:string;
//   weeklyOccuron:Array<any>;
// }

type MeetingScheduleState = {
  isMoreDetail: boolean;
  timeEdit: boolean;
  meetingDetail: meetingDetails;
  timeZoneValue: any;
  showEndhours: string;
  personalMeetingId: string;
  isRecurring: boolean;
  is_speaking_lang: boolean;
  rruleOption: any;
  s_Date_Calender: Date;
  e_Date_Calender: any;
  rruleText: any;
  max_duration: any;
  max_Time: any;
  spech_Search: string;
  ast_default_Spe_Opt: string;
  isSpeakView: boolean;
  endAt: string;
  isCancelMeetingModalVisible: boolean;
  alternateHostDetails: any;
  participantSipDetails: any;
  buttonEnableStatus: any;
  openParticipant: boolean;
  allContacts: any;
  contacts: any
  searchKey: string;
  filteredContacts: any;
  favContactsList: Array<any>;

};

const { Option } = Select;
export default function MeetingSchedule() {
  let { meetingReducer, contactReducer }: any = useSelector((state: any) => state);

  let { workContacts, favContacts } = contactReducer;
  let { getListInput,planBased } = meetingReducer;
  let timeDurationList: any = Array.from(Array(12).keys());
  let allday: any = Array.from(Array(25).keys());
  let countryZone: any = _.find(TIMEZONE, { id: Intl.DateTimeFormat().resolvedOptions().timeZone });
  //var travelTime = (moment().add(1, 'hours').format('hh:mm A')).split(" ");
  let { videoprofileData }: profileDetails = useSelector((state: any) => state.profileReducer);
  var interval = 30 * 60 * 1000; // 30 minutes in milliseconds
  let quarterHours: any = moment(new Date(Math.ceil(new Date().getTime() / interval) * interval)).format('hh:mm A').split(" ");
  let start_time: any = new Date(Math.ceil(new Date().getTime() / interval) * interval)
  var newCurrentDate = new Date();
  // const setHours1 = (dt: Date, h: string) => {
  //   try {
  //     let s: any = /(\d+):(\d+)(.+)/.exec(h);
  //     dt.setHours(s[3] === "pm" ?
  //       12 + parseInt(s[1], 10) :
  //       parseInt(s[1], 10));
  //     dt.setMinutes(parseInt(s[2], 10));
  //   }
  //   catch (e: any) { console.log("setHour error", e); }
  // };

  let favList: Array<any> = _.filter(favContacts, ((contacts: any) => {
    return !Object.keys(contacts).some(key => key === 'team_id_prefix');
  }));
  const [recurrenceMeetingBtn, setRecurrenceMeetingBtn] = useState(false)
  const [alternateHostBtn, setAlternateHostBtn] = useState(false)
  const [timepickEdit, setTimepickEdit] = useState(false);
  const getEndstring = (startDate: Date, hrMin: string, isAmPm: string, duratin: any) => {
    let newDate: Date = new Date(startDate);
    let splitHrMin = hrMin.split(":");
    let timeFormat: any = getTimeFormatAMPM(splitHrMin, isAmPm);
    newDate.setHours(timeFormat);
    newDate.setMinutes(parseInt(splitHrMin[1]));
    let splitDuration: any = duratin?.toString()?.split(":");
    let endDate: any = newDate.setHours(newDate.getHours() + parseInt(splitDuration[0]), newDate.getMinutes() + parseInt(splitDuration[1]));
    if (moment(moment().format('yyyy-MM-DD')).isSame(moment(endDate).format('yyyy-MM-DD'))) { return 'The meeting will end at ' + moment(endDate).format('hh:mm a') }
    else {
      return 'The meeting will  end on '
        + moment(endDate).format('yyyy-MM-DD').toLowerCase() + ' at ' + moment(endDate).format('hh:mm a');
    }
  };
  // const getEndDateValue=(startDate: Date, hrMin: string, isAmPm: string, duratin: number)=>{
  //   let newDate: Date = new Date(startDate);
  //   setHours(newDate, hrMin + isAmPm);
  //   let endDate: Date = new Date(new Date(newDate).setHours(newDate.getHours() + duratin));

  //   return endDate;
  // }



  const selectDropDown = () => {

    let element: HTMLElement | any = document.getElementById("meetSchedule") || null;

    if (element != null) {
      if (element.hasAttribute('scroll') === true) {
        element.removeAttribute("scroll");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "none";
        element.style["overflow-y"] = "overlay";

      }
      else {
        element.setAttribute("scroll", "no");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "block";

        element.style["overflow"] = "hidden";
      }
    };

  };



  const [getData, setData] = useState<MeetingScheduleState>({
    isMoreDetail: false,
    alternateHostDetails: [],
    participantSipDetails: [],
    meetingDetail: {
      status: 'Start',
      title: 'My Meeting',
      description: '',
      dial_in_countries: [],
      start_timestamp: start_time,
      end_timestamp: new Date(),
      is_alternate_host: false,
      time: { hours: '1', minutes: "00" },
      isAmPM: (quarterHours[1]),
      duration: { hours: '1', minutes: "00" },
      duration_minutes: 60,
      participants: [],
      timezone: countryZone?.name || '(GMT+05:30) India Standard Time',
      calender_type: 'none',
      is_host_myvideo: videoprofileData?.schedule?.host_video !== undefined ? videoprofileData?.schedule?.host_video : true,
      is_host_myaudio: true,
      is_participant_video: videoprofileData?.schedule?.participants_video !== undefined ? videoprofileData?.schedule?.participants_video : true,
      is_participant_waiting_room: videoprofileData?.security?.wating_room !== undefined ? videoprofileData?.security?.wating_room : true,
      is_record_meeting: false,
      requireAuthentication: false,
      authenticationJoin: "Anyone",
      is_participant_join_bef_host: false,
      is_participant_invite_guest: false,
      is_participant_mute_entry: false,
      alternate_host: [],
      is_use_personal_meeting_id: false,
      personal_meeting_id: getMeetingId(),
      meeting_id: uuidv4(),
      is_custom_password: false,
      password: generatePassword(),
      recurrence: "None",
      rrule: "",
      save_template: false,
      joining_option_type: 'link',
      is_without_host_continue: true,
      speakingLanguage: 'en',
      files: [],
      restrictScreenShare: false
    },
    timeZoneValue: TIMEZONE,
    showEndhours: '',
    personalMeetingId: getMeetingId(),
    isRecurring: false,
    is_speaking_lang: false,
    rruleOption: {
      isRecurringEvent: false,
      repeat_every: 1,
      value_disabled: true,
      afteroccur: 7,
      occurOnDay: newCurrentDate.getDate(),
      monthlyOccureon: true,
      monthlyWeek: "First",
      monthlyDay: "Sun",
      weeklyOccuron: []
    },
    s_Date_Calender: start_time,
    e_Date_Calender: new Date(),
    max_duration: '01:00',
    max_Time: quarterHours[0],
    spech_Search: '',
    rruleText: '',
    ast_default_Spe_Opt: 'Global English (en)',
    isSpeakView: false,
    endAt: getEndstring(new Date(), quarterHours[0], quarterHours[1], '01:00'),
    isCancelMeetingModalVisible: false,
    buttonEnableStatus: false,
    openParticipant: false,
    allContacts: workContacts,
    contacts: workContacts,
    searchKey: "",
    filteredContacts: [],
    favContactsList: []
  });

  useEffect(() => {
   
    // {RecurrenceMeeting while schedule}
    const RecurrenceMeeting = planBased.find((item:any) => item.featureid === 3);
    if (RecurrenceMeeting && RecurrenceMeeting.value1 === "Yes") {
      setRecurrenceMeetingBtn(false); 
    } else {
      setRecurrenceMeetingBtn(true);
    }

     // {AlternateHost while schedule}
    const AlternateHost = planBased.find((item:any) => item.featureid === 20);
    if (AlternateHost && AlternateHost.value1 === "Yes") {
      setAlternateHostBtn(false); 
    } else {
      setAlternateHostBtn(true);
    }
  
  }, [planBased]); 

  useEffect(() => {

    let timeset: any = document.getElementById("appt");
    let time = getCurrentTime();
    console.log("timetime", time)
    if (timeset) {
      timeset.value = getCurrentTime();
    }
    if (getData.alternateHostDetails) {
      let filterdList: any = workContacts; let fav_contacts: any = favList;
      filterdList = _.filter(filterdList, function (o: any) {
        return !getData.alternateHostDetails.includes(o.sip_login_id);
      });
      fav_contacts = _.filter(favList, function (o: any) {
        return !getData.alternateHostDetails.includes(o.sip_login_id);
      });
      setData({ ...getData, allContacts: filterdList, filteredContacts: filterdList, favContactsList: fav_contacts })
    }
    else {
      setData({ ...getData, allContacts: workContacts, favContactsList: favList })
    }
  }, [getData.alternateHostDetails]);

  let resContact: any = searchHandler(workContacts, getData.searchKey);
  let len = Math.ceil((resContact?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  const fileOnchange = (files: any) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, files: files } });
  };

  const moreOptionTrigger = () => {
    setData({ ...getData, isMoreDetail: !getData.isMoreDetail });
  };

  // const disabledStartDate = (from: any, current: any) => {
  //   return new Date(from.setDate(from.getDate() - 1)) >= current;
  // };

  const disabledEndDate = (from: any, current: any) => {
    let customDate = moment().format("YYYY-MM-DD");

    // let firstDay =  moment().add(-1,'days').format("YYYY-MM-DD");
    let fiftyDay = moment().add(50, 'days').format("YYYY-MM-DD");

    return current < moment(customDate, "YYYY-MM-DD") || moment(fiftyDay, "YYYY-MM-DD") <= current
  };

  const videoShowHideStatus = (key: string, value: any) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, [key]: value } });
  };

  const updateMultiCheckbox = (value: any) => {
    let { weeklyOccuron } = getData.rruleOption;
    let index = (weeklyOccuron).indexOf(value);
    if (index !== -1) { weeklyOccuron.splice(index, 1); }
    else { weeklyOccuron.push(value); }
    getData.rruleOption['weeklyOccuron'] = weeklyOccuron;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender,
      getData.e_Date_Calender);

    setData({
      ...getData, rruleOption: { ...getData.rruleOption, weeklyOccuron: weeklyOccuron },
      meetingDetail: { ...getData.meetingDetail, rrule: ruleIs.toString() }, rruleText: ruleIs.toText()
    });
  };

  const dateTimeSelectOpt = (value: any) => {

    if (getData.meetingDetail.recurrence !== "None" && getData.rruleOption.value_disabled) {
      let endDate = getEndDate(getData.meetingDetail.recurrence, getData.rruleOption.repeat_every, value);
      getData['e_Date_Calender'] = endDate;
      getData['s_Date_Calender'] = value;
      let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence, value, endDate);
      setData({
        ...getData, meetingDetail: {
          ...getData.meetingDetail, rrule: ruleIs.toString()
        }, s_Date_Calender: value, e_Date_Calender: endDate, rruleText: ruleIs.toText()
      });
    }
    else {
      let endtAt = getEndstring(new Date(value), getData.max_Time, getData.meetingDetail.isAmPM,
        getData.max_duration);
      setData({ ...getData, s_Date_Calender: value, endAt: endtAt });
    }
  };

  const timeZoneOnchange = (value: any) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, timezone: value } });
  };

  const am_TO_pm_Onchange = (value: any) => {
    let endtAt = '';
    if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
      endtAt = getEndstring(getData.s_Date_Calender, getData.max_Time, value,
        getData.max_duration);
    }
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, isAmPM: value }, endAt: endtAt });
  };

  const setTime = (key: any, e: any) => {
    let endtAt: string = '';
    if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
      endtAt = getEndstring(getData.s_Date_Calender, e.target.value, getData.meetingDetail.isAmPM,
        getData.max_duration);
    }
    setData({ ...getData, [key]: e.target.value, endAt: endtAt });
  }
  const handletimeedit = (value: any) => {
    setTimepickEdit(value);
  }
  const defaultValueOnchange = (key: string, value: any) => {
    let endtAt: string = '';
    if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
      if (key === 'max_Time') {
        endtAt = getEndstring(getData.s_Date_Calender, value, getData.meetingDetail.isAmPM,
          getData.max_duration);
      }
      else {
        endtAt = getEndstring(getData.s_Date_Calender, getData.max_Time, getData.meetingDetail.isAmPM, value);
      }
    }
    setData({ ...getData, [key]: value, endAt: endtAt });

  };

  const selectRecurrenceOption = (e: any) => {
    let endDate = getEndDate(e.key, getData.rruleOption.repeat_every, getData.s_Date_Calender);
    getData.meetingDetail['recurrence'] = e.key;
    getData['e_Date_Calender'] = endDate;
    if (e.key !== "None") {
      let ruleIs = rRuleFrame(getData.rruleOption, e.key, getData.s_Date_Calender, endDate);
      setData({
        ...getData, meetingDetail:
          { ...getData.meetingDetail, recurrence: e.key, rrule: ruleIs.toString() }
        , e_Date_Calender: endDate, rruleText: ruleIs.toText()
      });
    }
    else {
      setData({
        ...getData, meetingDetail:
          { ...getData.meetingDetail, recurrence: e.key, rrule: "" }
        , e_Date_Calender: "", rruleText: "", isRecurring: false
      });
    }
  };

  const selectRepeatOption = (e: any) => {

    let endDate = getEndDate(getData.meetingDetail.recurrence, e.key, getData.s_Date_Calender);
    getData.rruleOption['repeat_every'] = e.key;
    getData['e_Date_Calender'] = endDate;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender, endDate);
    setData({
      ...getData, rruleOption: {
        ...getData.rruleOption, repeat_every: e.key
      }
      , meetingDetail: {
        ...getData.meetingDetail, rrule: ruleIs.toString()
      }
      , e_Date_Calender: endDate, rruleText: ruleIs.toText()
    });
  };


  const selectOccurenceOption = (e: any) => {
    setData({ ...getData, rruleOption: { ...getData.rruleOption, afteroccur: e.key } });
  };

  const selectMonthyonchangeEvent = (key: any, e: any) => {

    getData.rruleOption[key] = e.key;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender, getData.e_Date_Calender);

    setData({
      ...getData, rruleOption: { ...getData.rruleOption, [key]: e.key }
      , meetingDetail: { ...getData.meetingDetail, rrule: ruleIs.toString() }, rruleText: ruleIs.toText()
    });
  };

  const meetingTextBoxChanges = (key: string, e: any) => {
    setData({
      ...getData, meetingDetail: {
        ...getData.meetingDetail,
        [key]: (key === 'password') ? (e.target.value).trim() : e.target.value
      }
    });
  };

  const alternateHostDetail = (value: any, obj: any) => {
    try {
      let sipIdList: any = [];
      if (!_.isEmpty(value)) {
        let data = JSON.parse(obj[0].key);
        let HostDetail = {
          email: data.email_id,
          ext: data.ext,
          name: data.caller_id,
          profile_img: data.ImageURL,
          roletype: 2,
          sipid: data.sip_login_id,
          user_type: "company"
        };
        sipIdList.push(data.sip_login_id)

        let findIndex: any = getData.participantSipDetails.indexOf(data.sip_login_id);

        let index: number = _.findIndex(getData.meetingDetail.participants, { sipid: parseInt(data.sip_login_id) });

        /* let participants = getData.meetingDetail.participants */
        if (index !== -1) {
          getData.meetingDetail.participants.splice(index, 1);
        }

        if (findIndex !== -1) {
          getData.participantSipDetails.splice(findIndex, 1);
        }

        setData({
          ...getData, alternateHostDetails: sipIdList, participantSipDetails: getData.participantSipDetails, meetingDetail: {
            ...getData.meetingDetail, alternate_host: HostDetail, participants: getData.meetingDetail.participants
          }
        });
      }
      else {
        setData({
          ...getData, alternateHostDetails: [], meetingDetail: { ...getData.meetingDetail, alternate_host: [] }
        });
      }
    } catch (error) {
      console.log("error");
    }
  };

  const waitingRoomOnchange = (key: string, e: any) => {
    // if (key === 'is_participant_waiting_room') {
    setData({
      ...getData, meetingDetail: {
        ...getData.meetingDetail, [key]: e.target.checked
      }
    });
    // }
    // else {
    //   setData({
    //     ...getData, meetingDetail: {
    //       ...getData.meetingDetail, [key]: e.target.checked,
    //       is_participant_waiting_room: !e.target.checked
    //     }
    //   });
    // }
  };

  const RecurringOnChange = (e: any) => {
    let endtAt = '';
    let checkbox = !getData.isRecurring
    if (!checkbox) {
      endtAt = getEndstring(getData.s_Date_Calender, getData.max_Time, getData.meetingDetail.isAmPM,
        getData.max_duration);
    }
    setData({
      ...getData, isRecurring: checkbox, endAt: endtAt,
      meetingDetail: { ...getData.meetingDetail, recurrence: "None", rrule: "" }, rruleText: ""
    });
  };

  const outsideMeetingDetail = (key: string, e: any) => {
    setData({ ...getData, [key]: e.target.checked });
    if (key === "is_speaking_lang") {
      let checkbox: any = !getData.is_speaking_lang;
      setData({ ...getData, is_speaking_lang: checkbox });
    }
  };

  const meetingDetailStore = (key: string, e: any) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, [key]: e.target.checked } });
  };

  const calenderOnchange = (value: string) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, calender_type: value } });
  };

  const joiningOptionOnchange = (value: string) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, joining_option_type: value } });
  };

  const searchInput = (e: string) => {
    let searchText = e.toLowerCase();
    const filterZone: Array<any> = TIMEZONE
      .filter((value: any) => value.name.toLowerCase().includes(searchText));
    setData({ ...getData, timeZoneValue: filterZone });
  };

  const onMeetingIdChange = () => {
    let passRes: any = getData.meetingDetail.is_use_personal_meeting_id === true ? generatePassword() : videoprofileData?.security?.passcode;
    setData({
      ...getData, meetingDetail: {
        ...getData.meetingDetail,
        is_use_personal_meeting_id: !getData.meetingDetail.is_use_personal_meeting_id,
        password: passRes
      }
    });
  };

  const rruleCheckBoxOnchange = () => {
    getData.rruleOption['value_disabled'] = !getData.rruleOption.value_disabled;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender,
      getData.e_Date_Calender);
    setData({
      ...getData, rruleOption: { ...getData.rruleOption, value_disabled: getData.rruleOption.value_disabled },
      meetingDetail: { ...getData.meetingDetail, rrule: ruleIs.toString() }, rruleText: ruleIs.toText()
    });
  };

  const rruleMonthlyBoxOnchange = () => {
    getData.rruleOption['monthlyOccureon'] = !getData.rruleOption.monthlyOccureon;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender, getData.e_Date_Calender);
    setData({
      ...getData, rruleOption: { ...getData.rruleOption, monthlyOccureon: getData.rruleOption.monthlyOccureon },
      meetingDetail: { ...getData.meetingDetail, rrule: ruleIs.toString() }, rruleText: ruleIs.toText()
    });
  };

  const handleDateChange = (value: any) => {
    getData['e_Date_Calender'] = value;
    if (value) {
      let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
        getData.s_Date_Calender, value);
      setData({
        ...getData,
        meetingDetail: { ...getData.meetingDetail, rrule: ruleIs.toString() }
        , e_Date_Calender: value, rruleText: ruleIs.toText()
      });
    }
  };

  const updateStatus = (key: any, value: any) => {
    setData({ ...getData, [key]: value });
  };


  const timeListShow = timeDurationList.map((value: string, index: number) => {

    return (
      <>{index === 0 ?
        <>
          <Option value={'00:00'}
            key={`${index}:00`}>{`12:00`}</Option>
          <Option value={'00:30'}
            key={`${index}:30`}>{`12:30`}</Option>
        </>
        :
        <>
          <Option value={`${value.toString().length === 1 ? '0' + value : value}:00`}
            key={`${index}:00`}>{`${value.toString().length === 1 ? '0' + value : value}:00`}</Option>
          <Option value={`${value.toString().length === 1 ? '0' + value : value}:30`}
            key={`${index}:30`}>{`${value.toString().length === 1 ? '0' + value : value}:30`}</Option>
        </>
      }
      </>
    );
  });
  const durationListShow = allday.map((value: string, index: number) => {
    return (
      <>{index === 0 ?
        <>
          <Option value={`${value}0: 30`}
            key={`${index}30`}>{`30m`}</Option>
        </>
        : (index > 11) ?
          <>
            <Option value={`${value.toString().length === 1 ? '0' + value : value}: 00`}
              key={`${index}:00`}>{`${value + 'h'}`}</Option>
          </> :
          <>
            <Option value={`${value.toString().length === 1 ? '0' + value : value}: 00`}
              key={`${index}:00`}>{`${value + 'h'}`}</Option>
            {index !== 24 && <Option value={`${value.toString().length === 1 ? '0' + value : value}:30`}
              key={`${index}:30`}>{`${value + 'h'} 30m`}</Option>}
          </>
      }
      </>
    );
  });

  // const finalMergeData = () => {
  //   try {
  //     const cpyGetData:any =  {...getData};
  //     cpyGetData.meetingDetail.title = (cpyGetData.meetingDetail.title).trim();
  //     if (cpyGetData.meetingDetail.title === "") { cpyGetData.meetingDetail.title = 'New Meeting 1'; }

  //     cpyGetData.meetingDetail.duration_minutes = (60 * cpyGetData.max_duration);
  //     cpyGetData.meetingDetail.duration = { hours: cpyGetData.max_duration, minutes: "00" };


  //     let newDate: Date = new Date(cpyGetData.s_Date_Calender);
  //     setHours(newDate, cpyGetData.max_Time + cpyGetData.meetingDetail.isAmPM);
  //     cpyGetData.meetingDetail.start_timestamp = newDate.getTime();
  //     if (cpyGetData.meetingDetail.recurrence === "None") {
  //       let endDate: Date = new Date(newDate.getTime());
  //       endDate.setHours(endDate.getHours() + parseInt(cpyGetData.meetingDetail.duration.hours));
  //       cpyGetData.meetingDetail.end_timestamp = endDate.getTime();
  //     }
  //     else { cpyGetData.meetingDetail.end_timestamp = new Date(cpyGetData.e_Date_Calender).getTime(); }

  //     cpyGetData.meetingDetail.time = {
  //       hours: (cpyGetData.max_Time).split(":")[0],
  //       minutes: (cpyGetData.max_Time).split(":")[1]
  //     };


  //     if(cpyGetData.meetingDetail.is_alternate_host && cpyGetData.meetingDetail.alternate_host.length !== 0) {
  //       cpyGetData.meetingDetail.participants.push(cpyGetData.meetingDetail.alternate_host);
  //     }
  //     return cpyGetData.meetingDetail;
  //   }
  //   catch (e: any) {
  //     toastInformation("Something went wrong Please try again", "failure");
  //   }
  // };

  const createMeeting = () => {
    // let finalData: any = finalMergeData();
    setData({ ...getData, buttonEnableStatus: true });
    let currentUserInfo = getPersonalData();

    const { meetingDetail, max_duration, s_Date_Calender, max_Time }: any = { ...getData };
    let inputDetails: any = { ...meetingDetail };
    let participantsArray = [...inputDetails.participants];

    inputDetails.title = (inputDetails.title).trim();
    if (inputDetails.title === "") { inputDetails.title = 'My Meeting'; }
    if (inputDetails.is_alternate_host && inputDetails.alternate_host.length === 0) { inputDetails.is_alternate_host = false };
    let splitDuration: any = max_duration.split(":");
    inputDetails.duration_minutes = (60 * parseInt(splitDuration[0])) + parseInt(splitDuration[1]);
    inputDetails.duration = { hours: splitDuration[0], minutes: splitDuration[1] };

    let newDate: Date = new Date(s_Date_Calender);
    let splitHrMin = getData.max_Time.split(":");
    let timeFormat: any = getTimeFormatAMPM(splitHrMin, getData.meetingDetail.isAmPM);
    newDate.setHours(timeFormat);
    newDate.setMinutes(parseInt(splitHrMin[1]));
    inputDetails.start_timestamp = newDate.getTime();
    if (inputDetails.recurrence === "None") {
      let endDate: Date = new Date(newDate.getTime());
      endDate.setHours(endDate.getHours() + parseInt(inputDetails.duration.hours));
      endDate.setMinutes(endDate.getMinutes() + parseInt(inputDetails.duration.minutes));
      inputDetails.end_timestamp = endDate.getTime();
    }
    else {
      let endDate: Date = new Date(newDate.getTime());
      endDate.setHours(endDate.getHours() + parseInt(inputDetails.duration.hours));
      endDate.setMinutes(endDate.getMinutes() + parseInt(inputDetails.duration.minutes));
      inputDetails.end_timestamp = endDate.getTime();
      inputDetails.end_timestamp = endDate.getTime();
    }

    inputDetails.time = {
      hours: (max_Time).split(":")[0],
      minutes: (max_Time).split(":")[1]
    };

    if (inputDetails.is_alternate_host && inputDetails.alternate_host.length !== 0) {
      participantsArray.push(inputDetails.alternate_host);
    }
    participantsArray.push(currentUserInfo);
    inputDetails.participants = participantsArray;
    if (getData.meetingDetail.is_custom_password && getData.meetingDetail.password.trim() === "") {
      toastInformation("You have enabled custom password,Password should not be empty", "failure");
      setData({ ...getData, buttonEnableStatus: false })
      return;
    }
    else if (getData.meetingDetail.is_alternate_host && getData.meetingDetail.alternate_host.length === 0) {
      toastInformation("You have enabled alternate host", "failure");
      setData({ ...getData, buttonEnableStatus: false })
      return;
    }
    if (getData.meetingDetail.is_custom_password && getData.meetingDetail.password.length < 3) {
      toastInformation("password must be 3 or more character");
      setData({ ...getData, buttonEnableStatus: false })
      return;
    }
    if (!getData.buttonEnableStatus) {
      return new Promise<void>((resolve, reject) => {

        new meetingSDK.MeetingRestService().createMeeting(inputDetails).then((result: any) => {
          if (result?.statusCode === 200) {
            toastInformation("Meeting created successfully", "success");
            calendarType(inputDetails, result.inviteUrl);
            store.dispatch({
              type: Types.VIDEOMEET_COUNT_STATUS,
              payload: {
                meetingCountStatus:true
              }
            })
            updateMeetingRead(result?.uuid);
            new meetingSDK.MeetingRestService().getMeetingsByUuid(result.uuid).then((res: any) => {
              if (res?.statusCode === 200) {
                storeMeetingPage(res.result);
                storeWindowState("meetingDetails");
                setData({ ...getData, buttonEnableStatus: false })
              }
            })
            let data: any = {};
            data.offset = 0;
            data.limit = 10;
            data.filter = getListInput.filter;
            data.searchText = '';
            data.sort = getListInput.sort;
            getMeetingLists(data);
          }
          else {
            setData({ ...getData, buttonEnableStatus: false })
            toastInformation("Something went wrong", "failure");

          }
        })
          .catch((err: any) => {
            toastInformation(err, "failure");
            setData({ ...getData, buttonEnableStatus: false })
          });
      })
    }

  }
  const cancelMeeting = () => {

    setData({
      ...getData, isCancelMeetingModalVisible: true
    });
  };

  const openParticipant = () => {
    let status = getData.openParticipant;
    setData({
      ...getData, openParticipant: !status
    });
  }
  const cancelMeetingConfirm = () => {
    setData({
      ...getData, isCancelMeetingModalVisible: false
    });
    storeWindowState('mainPage');
  };

  const handleJoin = (e: any) => {

    let data = e.key === "0" ? "Anyone" : e.key === "1" ? "Only contacts" : "All signed in user"
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, authenticationJoin: data } });
  }

  const setSelectTime = (key: any, e: any) => {
    setTimepickEdit(false);
    let endtAt: string = '';
    if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
      endtAt = getEndstring(getData.s_Date_Calender, e.key, getData.meetingDetail.isAmPM,
        getData.max_duration);
    }
    setData({ ...getData, [key]: e.key, endAt: endtAt });
  }

  // const participantDetail = (detail: any,sipIdList:any) => {
  //  console.log("detail >>>>>>", detail);
  //  console.log("sipIdList >>>>>>", sipIdList);
  //   setData({ ...getData,participantSipDetails:sipIdList, meetingDetail: { ...getData.meetingDetail, participants: detail } });
  // };

  const { TextArea } = Input;

  const outPutLangSelectiondaily = (
    <Menu onClick={selectRecurrenceOption}>
      <Menu.Item key={"None"}>No Recurrence</Menu.Item>
      <Menu.Item key={"Daily"}>Daily</Menu.Item>
      <Menu.Item key={"Weekly"}>Weekly</Menu.Item>
      <Menu.Item key={"Monthly"}>Monthly</Menu.Item>
    </Menu>
  );

  let timePickerNewList: any = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  const timePickerNew = (
    <Menu className={`${"scroller"} timepic ${styles.timeSelect}`} onClick={(e: any) => setSelectTime("max_Time", e)}>
      {timePickerNewList.map((value: string, index: number) => {
        return (
          <>
            <Menu.Item
              key={`${value.toString().length === 1 ? '0' + value : value}:00`}>{`${value.toString().length === 1 ? '0' + value : value}:00`}</Menu.Item>
            <Menu.Item key={`${value.toString().length === 1 ? '0' + value : value}:30`}
            >{`${value.toString().length === 1 ? '0' + value : value}:30`}</Menu.Item>
          </>
        );
      })
      }
    </Menu>
  );


  let repeatCount = getData.meetingDetail.recurrence === "None" ? 0 :
    (getData.meetingDetail.recurrence === 'Daily' ? 15 :
      (getData.meetingDetail.recurrence === 'Weekly') ? 12 : 3);
  let repeatDay: any = Array.from(Array(repeatCount).keys());

  const repeatEveryOpt = (
    <Menu onClick={selectRepeatOption}>
      {repeatDay.map((list: any) => {
        return (<> <Menu.Item key={list + 1}>{list + 1}</Menu.Item> </>);
      })}
    </Menu>
  );

  const selectOccurenceMenu = (
    <Menu onClick={selectOccurenceOption}>
      {repeatDay.map((list: any) => {
        return (<> <Menu.Item key={list + 1}>{list + 1}</Menu.Item></>);
      })}
    </Menu>
  );

  let monthlyDays: any = Array.from(Array(31).keys());
  const monthlyDayMenu = (
    <Menu onClick={(e: any) => selectMonthyonchangeEvent('occurOnDay', e)}>
      {monthlyDays.map((list: any) => {
        return (<> <Menu.Item key={list + 1}>{list + 1}</Menu.Item></>);
      })}
    </Menu>
  );

  // let Userjoin: any = Array.from(Array(31).keys());
  const UserJoinMenu = (
    <Menu onClick={(e: any) => handleJoin(e)}
      items={[
        {
          label: <span>Anyone </span>,
          key: 0
        },
        {
          label: <span>Only contacts </span>,
          key: 1
        },
        {
          label: <span>All signed in user</span>,
          key: 2
        }

      ]}
    />
  );
  let weekMode: any = ['First', 'Second', 'Third', 'Fourth', 'Last'];
  const weeklyModeOnchange = (
    <Menu onClick={(e: any) => selectMonthyonchangeEvent('monthlyWeek', e)}>
      {weekMode.map((list: any) => {
        return (<> <Menu.Item key={list}>{list}</Menu.Item></>);
      })}
    </Menu>
  );

  let monthMode: any = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const selectMonthDayOnchange = (
    <Menu onClick={(e: any) => selectMonthyonchangeEvent('monthlyDay', e)}>
      {monthMode.map((list: any) => {
        return (<> <Menu.Item key={list.substring(0, 3)}>{list}</Menu.Item></>);
      })}
    </Menu>
  );

  const textBoxSpecOnchange = (keyPress: any) => {
    setData({ ...getData, spech_Search: keyPress.target.value });
  };

  const handle_Spec_VisibleChange = (flag: any) => {
    setData({ ...getData, isSpeakView: flag });
  };
  const updateInputLanguage = (lan: string, code: string) => {
    setData({
      ...getData, ast_default_Spe_Opt: lan + " (" + code + ")", isSpeakView: false,
      meetingDetail: { ...getData.meetingDetail, speakingLanguage: code }
    });
  };

  const closeCancelMeetingModal = () => {
    setData({ ...getData, isCancelMeetingModalVisible: false });
  };

  const updateMeetingDetail = (key: any, status?: any) => {

    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, [key]: status } })
    // if(key === "is_participant_join_bef_host")
    // {
    //   setData({ ...getData, meetingDetail: { ...getData.meetingDetail,is_participant_waiting_room:status ? false:true,[key] :status } })
    // }
    // else if (key === "is_participant_waiting_room")
    // {
    //   setData({ ...getData, meetingDetail: { ...getData.meetingDetail, is_participant_join_bef_host: status ? false : true,[key] :status } })
    // }
    // else {
    //   console.log("need to handle");
    // }
  };

  const selectBoxOnchange = (val: any, obj: any) => {


    try {

      let participantDetails: any = [];
      let participantSipidList: any = [];
      obj.map((store: any) => {
        let data = JSON.parse(store.key);
        let HostDetail = {
          email: data.email_id,
          ext: data.ext,
          name: data.caller_id,
          profile_img: data.ImageURL,
          roletype: 3,
          sipid: data.sip_login_id,
          user_type: "company"
        };
        participantDetails.push(HostDetail);
        participantSipidList.push(parseInt(data.sip_login_id))
      });
      setData({ ...getData, meetingDetail: { ...getData.meetingDetail, participants: participantDetails }, participantSipDetails: participantSipidList, searchKey: "", allContacts: getData.filteredContacts });

      //  participantDetail(participantDetails,participantSipidList);

    } catch (e: any) {
      console.log("selectBoxOnchange >>>>>", e)
    }


  };

  const contactFocus = () => {
    setData({ ...getData, searchKey: "", allContacts: getData.filteredContacts });
  };

  const searchContact = (e: string) => {
    let searchName = e.toLowerCase();
    if (searchName !== "") {
      let filtered = _.filter(getData.filteredContacts, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      let filteredFav = _.filter(favList, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      setData({ ...getData, allContacts: filtered, searchKey: searchName, favContactsList: filteredFav });
    }
    else { setData({ ...getData, allContacts: getData.filteredContacts, searchKey: searchName, favContactsList: favList }); }
  };

  const onBlur = (e: any) => {
    if (getData.meetingDetail.is_custom_password && getData.meetingDetail.password.length < 3) { toastInformation("password must be 3 or more character") }
  }

  let ASR_Data: any = store.getState().ASR_Language || [];
  let asrSpecLanguage = asrSearchLanguage(ASR_Data.list, getData.spech_Search);
  const outPutLangSelection = (
    <div className={styles.autoTranslateLangs}>
      <span className={styles.topsecTxtTitle}>Set Your Speaking language</span>
      <div className={styles.searchBox}><URInput placeHolder='Search'
        className='searchBoxlanglist' onChange={textBoxSpecOnchange} /></div>
      <ul className={`scroller ${styles.langList}`}>
        {asrSpecLanguage.map((elem: any, index: number) => {
          return (<li key={index} className={(getData.ast_default_Spe_Opt.includes(elem.languageName)) ? styles.selected : ""}
            onClick={() => updateInputLanguage(elem.languageName, elem.languageCode)}>
            {(getData.ast_default_Spe_Opt.includes(elem.languageName)) &&
              <span className="icon_tick"></span>}
            {elem.languageName + " (" + elem.languageCode + ")"}</li>);
        })
        }
      </ul>
    </div>
  );

  return (
    <>
      <div className={styles.mainInnerConSec}>
        <div className={styles.meetingformCon}>
          <div className={styles.topmeethead}>
            <h4>Meeting Details</h4>
          </div>

          <div className={styles.formGroup}>
            <div className={styles.scheduleTitle}>
              <URInput name="" className={`inputcustomBox newFocusGreen ${styles.custIn}`}
                value={getData.meetingDetail.title}
                onChange={(e: any) => meetingTextBoxChanges('title', e)} maxLength={80} />
              <span className={styles.inputright}>{80 - getData.meetingDetail.title.length}</span>
            </div>
            <div className={styles.txtareacon}>
              <TextArea rows={3} placeholder="Meeting Description" className="customTextareaBox"
                value={getData.meetingDetail.description}
                onChange={(e: any) => meetingTextBoxChanges('description', e)} maxLength={2000} />
            </div>
          </div>
          {!getData.openParticipant && <div className={`${styles.participantTop} ${styles.linktopheader}`}>
            <div className={styles.userName} onClick={openParticipant}>
              <span className="icon_plus"></span>
              <label>Participant</label> </div>
          </div>}
          {getData.openParticipant && <div className={`${styles.participantTop} ${styles.leftpartbtmside}`}>
            <div className={styles.userName}><span className="icon_profile"></span>
              Participant <span className={styles.titleHost}>{`(${getData?.meetingDetail?.participants?.length})`}</span></div>
          </div>}
          {getData.openParticipant && <div className={styles.participantdropcus}>
            <div className={styles.insideicon}>
              {getData.participantSipDetails.length === 0 && <img src={taskimg2} alt="" />}
              <Select
                /*  labelInValue = {true} */
                mode='multiple'
                style={{ width: '100%' }}
                placeholder="Select contacts or add email by comma seperation"
                className={getData.participantSipDetails.length === 0 ? "newselects taskcreations customdropbox " : "newselects taskcreations customdropbox inputselectlftnone meetingParticipantSel"}
                dropdownClassName="newChatSel meetingdropdown"
                /*  optionLabelProp="label" */
                value={getData.participantSipDetails}
                showSearch={true}
                filterOption={false}
                onDropdownVisibleChange={selectDropDown}
                onChange={selectBoxOnchange}
                onSearch={searchContact}
                onFocus={contactFocus}
              >

                {/* {allcontact} */}
                {/* { (favList?.length > 0 &&getData.searchKey==='') && 
          <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favList?.map((contactName: any, index: any) => {

            return <div key={index}>
              <div className="dropdowndesign">
                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')}/></>) :
                      (<>
                        <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')} />
                      </>)
                  } />
                <div className="names">{contactName.caller_id}</div>
                <div className="ext">{contactName.ext }</div>
              </div>
            </div>;
          })} */}

                {/* {getData.allContacts?.length > 0 &&  <div className="titlesdrop">Contact</div>} */}
                {(favContacts?.length > 0) &&
                  <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                {getData.favContactsList?.map((favcontactName: any, index: any) => {

                  return <div key={index} value={favcontactName.sip_login_id}>

                    <div className="dropdowndesign">
                      <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                        profileInfo={
                          (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                            (<>
                              <img src={favcontactName.ImageURL} alt="" />
                              <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                            (<>
                              <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                              <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                            </>)
                        } />
                      <div className="names">{favcontactName.caller_id}</div>
                      <div className="ext">{favcontactName.ext}</div>
                    </div>
                  </div>;
                })}
                {getData.allContacts?.map((contactName: any, index: any) => {
                  const first = contactName?.caller_id?.split(" ");
                  const second = first[0].trim().charAt(0).toUpperCase() + first[1].trim().charAt(0).toUpperCase();
                  let highlighted: any = searchHighlight(contactName, getData.searchKey);
                  return <Option key={JSON.stringify(contactName)} value={contactName.sip_login_id}>
                    {/* {
                      ((getData.allContacts[index - 1])?.caller_id?.charAt(0).toUpperCase()) !==
                      (second) &&
                      <div className="titlesdrop">{second} </div>
                    } */}
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (contactName.ImageURL !== null && contactName.ImageURL !== "" && !contactName.ImageURL.includes('avatar.png')) 
                            ?
                              (<>
                                <img src={contactName.ImageURL} alt="" className={styles.imgSelected} />
                                <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{second} </span>
                                <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                              </>)
                          } />
                      </div>
                      {getData.searchKey !== '' ?
                        <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                          <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                          {highlighted?.lastMsg}</>) :
                          (<>{contactName?.caller_id}</>)}</div> :
                        <div className="names">{contactName.caller_id}</div>}
                      <div className="ext">{contactName.ext}</div>
                    </div>
                  </Option>;
                })}
              </Select>
            </div>
          </div>}


          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.meettimetxt}>
              {getData.meetingDetail.recurrence === "None" && <p>{getData.endAt}</p>}
            </div>
            <div className={styles.filterconmain}>

              <div className={`${styles.leftdatefil} ${styles.lfttopfil}`}>
                <div className={styles.shareSelect}>


                  {/* <DatePicker className="customDatepicker" format={'DD MMM YYYY'}
                    disabledDate={(e) => disabledStartDate(new Date(), e)}
                    defaultValue={moment(getData.s_Date_Calender,'DD MMM YYYY')}
                    dropdownClassName='datepickerDropdown' placeholder='Start date' onChange={dateTimeSelectOpt}/> */}


                  {/* <DatePicker className="customDatepicker meetingdate meetlfticonremove" format={'DD MMM YYYY'}
                    disabledDate={(e) => disabledStartDate(new Date(), e)}
                    onChange={dateTimeSelectOpt}
                    defaultValue={moment(new Date(), "DD MMM YYYY")}
                    defaultValue={moment(new Date(getData.s_Date_Calender))}
                    defaultValue={moment(getData.s_Date_Calender)}
                    value={moment(getData.s_Date_Calender)}
                    dropdownClassName='datepickerDropdown meetingDropdwn'
                    placeholder='Start date' /> */}
                  <DatePicker className="customDatepicker meetingdate meetlfticonremove customDateIcon" format={'DD MMM YYYY'}
                    disabledDate={(e) => disabledEndDate(new Date(), e)}
                    // value={moment(getData.s_Date_Calender)}
                    defaultValue={moment(new Date(), "DD MMM YYYY")}
                    dropdownClassName='datepickerDropdown meetingDropdwn'
                    placeholder='Start date' onChange={dateTimeSelectOpt}
                    disabled={getData.rruleOption.value_disabled === true ? false : true} />
                </div>
              </div>

              <div className={`${styles.righttimefil} ${styles.righttopfil}`}>
                <div className={styles.rightfilter}>
                  <label className={styles.colformLabel}>Starts</label>
                  {/* <div className={styles.shareSelect}>
                    <Select className="langSelSec cusSelDrp" defaultValue={getData.max_Time}
                      dropdownClassName='customSelectdrp'
                      style={{ width: 200 }} onChange={(e:any) => defaultValueOnchange('max_Time', e)} onDropdownVisibleChange={selectDropDown}>
                      {timeListShow}
                    </Select>
                  </div> */}

                  <div className={styles.clocktimiconsec}>
                    {/* <Select className="langSelSec cusSelDrp" defaultValue={getData.max_Time}
                      dropdownClassName='customSelectdrp'
                      style={{ width: 200 }} onChange={(e: any) => defaultValueOnchange('max_Time', e)} onDropdownVisibleChange={selectDropDown}>
                      {timeListShow}
                    </Select> */}
                    <input className={`${styles.timeEdit} ${(timepickEdit) ? styles.jhds : ''}`} type="time" id="appt" name="appt"
                      min="01:00" max="12:00" step="1800" required onChange={(e: any) => setTime("max_Time", e)} value={getData.max_Time} />
                    {/* <span className="icon_down-arrow"></span> */}
                    <Dropdown overlay={timePickerNew} trigger={['click']} className={styles.tpicker} overlayClassName="tPickeroverlay" placement="bottomRight"
                      onVisibleChange={handletimeedit}
                      getPopupContainer={trigger => trigger.parentNode}

                      visible={timepickEdit}>
                      <span className="icon_down-arrow"></span>
                    </Dropdown>
                  </div>

                  <div className={styles.shareSelect}>
                    <Select className="langSelSec cusSelDrp newGreenbdr" defaultValue={getData.meetingDetail.isAmPM.toUpperCase()}
                      dropdownClassName='customSelectdrp'
                      style={{ width: 200 }} onChange={am_TO_pm_Onchange} onDropdownVisibleChange={selectDropDown}>
                      {
                        ['AM', 'PM'].map((value: any, index: number) =>
                          <Option value={value}
                            key={index}>{`${value}`}</Option>)
                      }
                    </Select>
                  </div>
                </div>
              </div>

              <div className={styles.rightfilter}>
                <label className={styles.colformLabel}>Duration</label>
                <div className={styles.shareSelect}>
                  <Select className="langSelSec cusSelDrp newGreenbdr" defaultValue={getMaxDurationFormat(getData.max_duration)}
                    dropdownClassName='customSelectdrp'
                    style={{ width: 200 }} onChange={(e: any) => defaultValueOnchange('max_duration', e)} onDropdownVisibleChange={selectDropDown}>
                    {durationListShow}
                  </Select>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.timelfttopfil}>
              <div className={styles.shareSelect}>

                <Select
                  style={{ width: '100%' }}
                  defaultValue={getData.meetingDetail.timezone}
                  placeholder="Select timezone"
                  onChange={timeZoneOnchange}
                  filterOption={false}
                  showSearch={true}
                  onDropdownVisibleChange={selectDropDown}
                  className="selTimezone cusSelDrp timezonedrpdwn  newGreenbdr"
                  dropdownClassName='customSelectdrp'
                  onSearch={(e: string) => searchInput(e)}>
                  {
                    getData.timeZoneValue.map((d: any) =>
                      <Option value={d.name}
                        key={d.id}>{`${d.name}`}</Option>)
                  }
                </Select>

              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.radiomeet}>
              <div className={styles.radiospacealign}>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={() => calenderOnchange('google')}>
                  <URRadio checked={getData.meetingDetail.calender_type === 'google' ? true : false}
                  />
                  <span>Google Calendar</span>
                </div>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={() => calenderOnchange('outlook')}>
                  <URRadio checked={getData.meetingDetail.calender_type === 'outlook' ? true : false}
                  />
                  <span>Outlook Calendar</span>
                </div>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={() => calenderOnchange('iCalendar')}>
                  <URRadio checked={getData.meetingDetail.calender_type === 'iCalendar' ? true : false} />
                  <span>Download .ics</span>
                </div>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={() => calenderOnchange('none')} >
                  <URRadio checked={getData.meetingDetail.calender_type === 'none' ? true : false}
                  />
                  <span>None</span>
                </div>
              </div>
            </div>
          </div>
          <div className={`${recurrenceMeetingBtn ? `${styles.formGroup} ${styles.marBtmmax} disabledIcon` :`${styles.formGroup} ${styles.marBtmmax}`}`}>
            <div className={styles.checkmeet}  >
              <URCheckBox checked={getData.isRecurring}
                onChange={RecurringOnChange} className="checkboxborder" />
              <span className={styles.reguremeetxt} onClick={RecurringOnChange} >Recurring Meeting</span>


              {(getData.isRecurring && getData.meetingDetail.recurrence !== "None") &&
                <span className={styles.eventdaytxt}>{getData.rruleText}</span>
              }

            </div>
            {getData.isRecurring &&

              <div className={styles.recuringinnerConsec}>
                <div className={`${styles.recuringtopsec} ${styles.marbtmmin} ${styles.recurpadlft}`}>
                  <div className={styles.lftsidedrop}>
                    <div><span>Recurrence</span></div>
                    <div>
                      <div className={styles.shareSelect}>
                        <Dropdown overlay={outPutLangSelectiondaily} placement="bottomRight" trigger={['click']}
                          overlayClassName='customdrpBox'
                          className="cusBoxDrp">
                          <div className={`${styles.langSelSec} ${styles.daily}`}>
                            <span>{getData.meetingDetail.recurrence}</span>
                            <span className="icon_downarrow2"></span>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>

                  {getData.meetingDetail.recurrence !== "None" &&
                    <div className={styles.lftsidedrop}>
                      <div><span>Repeat every</span></div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={repeatEveryOpt} placement="bottomRight" trigger={['click']}
                            overlayClassName='customdrpBox'
                            className="cusBoxDrp">
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                              <span>{getData.rruleOption.repeat_every}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>{getData.meetingDetail.recurrence}</span></div>
                    </div>
                  }
                </div>
                {getData.meetingDetail.recurrence === 'Weekly' &&
                  <div className={styles.daySelect}>
                    <div className={styles.daySelectTit}><span>Occurs on</span></div>
                      <div className={`${styles.recuringtopsec} ${styles.marbtmmin} `}>
                        <div className={`${styles.checkmeet} ${styles.checpadright}`}>
                          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((value: any, index: any) =>
                            <div key={index} className={styles.dateHalf}><URCheckBox key={index}
                              checked={getData.rruleOption.weeklyOccuron.indexOf(value) !== -1}
                              onChange={(e: any) => updateMultiCheckbox(value)} />
                              <span className={styles.reguremeetxt}>{value}</span></div>
                          )
                          }
                        </div>
                      </div>
                  </div>

                }
                {getData.meetingDetail.recurrence === 'Monthly' &&
                  <div className={`${styles.recuringtopsec} ${styles.daySelect} ${styles.marbtmmin} `}>
                    <div className={styles.daySelectTit}><span>Occurs on</span></div>
                    <div className={styles.checkdaydrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={getData.rruleOption.monthlyOccureon}
                            onChange={rruleMonthlyBoxOnchange} /> <span>Day</span>
                        </div>
                      </div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={monthlyDayMenu} placement="bottomRight" trigger={['click']}
                            overlayClassName='customdrpBox'
                            className="cusBoxDrp">
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                              <span>{getData.rruleOption.occurOnDay}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>Of the month</span></div>
                    </div>
                  </div>}
                {getData.meetingDetail.recurrence === 'Monthly' &&
                  <div className={`${styles.recuringtopsec} ${styles.marbtmmin} `}>
                    <div className={styles.checkdaydrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={!getData.rruleOption.monthlyOccureon}
                            onChange={rruleMonthlyBoxOnchange} />
                        </div>
                      </div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={weeklyModeOnchange} placement="bottomRight" trigger={['click']}>
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                              <span>{getData.rruleOption.monthlyWeek}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={selectMonthDayOnchange} placement="bottomRight" trigger={['click']}>
                            <div className={`${styles.langSelSec} ${styles.days}`}>
                              <span>{getData.rruleOption.monthlyDay}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>Of the month</span></div>
                    </div>
                  </div>}

                {getData.meetingDetail.recurrence !== 'None' &&
                  <div className={`${styles.recuringtopsec} ${styles.marbtmmin}`}>
                    <div className={styles.lftsidedrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={getData.rruleOption.value_disabled}
                            onChange={rruleCheckBoxOnchange} /> <span>End Date</span>
                        </div>
                      </div>
                      <div>
                        <div className={styles.datepickerctst}>
                          <DatePicker className="customDatepicker meetingdate meetlfticonremove" format={'DD MMM YYYY'}
                            disabledDate={(e) => disabledEndDate(new Date(getData.s_Date_Calender), e)}
                            value={getData.e_Date_Calender !== null ? moment(getData.e_Date_Calender) : null}
                            dropdownClassName='datepickerDropdown meetingDropdwn'
                            placeholder='End date' onChange={handleDateChange}
                            disabled={getData.rruleOption.value_disabled === true ? false : true} />
                        </div>
                      </div>
                    </div>
                    <div className={styles.lftsidedrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={!getData.rruleOption.value_disabled}
                            onChange={rruleCheckBoxOnchange} /> <span>After</span>
                        </div>
                      </div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={selectOccurenceMenu} placement="bottomRight" trigger={['click']}
                            overlayClassName='customdrpBox'
                            className="cusBoxDrp">
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                              <span>{getData.rruleOption.afteroccur}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>Occurrence(s)</span></div>
                    </div>
                  </div>
                }

              </div>
            }
          </div>

          {/* <div className={styles.moredetailstxt} onClick={moreOptionTrigger}>
            <h4>More Details <span className={getData.isMoreDetail ? "icon_uparrow" : "icon_downarrow2"}
            ></span></h4>
          </div>

          {getData.isMoreDetail &&
            <> */}
          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.radiomeet}>
              <div className={styles.radiospacealign}>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={onMeetingIdChange}>
                  <URRadio checked={getData.meetingDetail.is_use_personal_meeting_id ? false : true}
                  />
                  <span>Generate a random meeting ID</span>
                </div>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={onMeetingIdChange}>
                  <URRadio checked={getData.meetingDetail.is_use_personal_meeting_id}
                  />
                  <span>Personal Meeting ID ({getData.personalMeetingId})</span>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.passmeet}>
              <div className={styles.passwordconsec}>
                <div onClick={() => updateMeetingDetail('is_custom_password', !getData.meetingDetail.is_custom_password)}>
                  <URCheckBox checked={getData.meetingDetail.is_custom_password}
                    onChange={(e: any) => meetingDetailStore('is_custom_password', e)} />
                  <label className={styles.passtxt}>Password</label>
                </div>
                {getData.meetingDetail.is_custom_password &&
                  <>
                    <div>
                      <Input placeholder="Enter password" onBlur={onBlur} maxLength={16}
                        className={` ${getData.meetingDetail.is_custom_password ? `${styles.formControl} ${styles.passInput}` : `${styles.formControl} ${styles.passInput} ${styles.disabledcus}`}  `}
                        value={getData.meetingDetail.password} disabled={!getData.meetingDetail.is_custom_password ? true : false}
                        onChange={(e: any) => meetingTextBoxChanges('password', e)} />
                    </div>
                  </>
                }
              </div>
              <p className={styles.userendpass}>Only user who enter password can join the meeting</p>
            </div>
          </div>
          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.radiomeetlink}>
              <div className={styles.radiospacealign}>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={(e: any) => joiningOptionOnchange('link')}>
                  <URRadio checked={getData.meetingDetail.joining_option_type === 'link' ? true : false}
                  /> <span>Link</span>
                </div>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={(e: any) => joiningOptionOnchange('dailIn')}>
                  <URRadio checked={getData.meetingDetail.joining_option_type === 'dailIn' ? true : false}
                  /> <span>Link and Dial In</span>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.switchtogglebtncon}>
              <div className={styles.switchtodleconsec}>
                <div className={styles.lfttoggle} onClick={() => updateMeetingDetail("is_host_myvideo", !getData.meetingDetail.is_host_myvideo)}>
                  <Switch size="small" checked={getData.meetingDetail.is_host_myvideo}
                    onChange={(e: any) => videoShowHideStatus('is_host_myvideo', e)} />
                  <span> {!getData.meetingDetail.is_host_myvideo ? 'OFF' : 'ON'}</span>
                  <label >(Host)</label>
                </div>
                <p className={styles.offtoglebtm}>Initially, host video in turned OFF</p>
              </div>
              <div className={styles.switchtodleconsec}>
                <div className={styles.lfttoggle} onClick={() => updateMeetingDetail('is_participant_video', !getData.meetingDetail.is_participant_video)}>
                  <Switch size="small" checked={getData.meetingDetail.is_participant_video}
                    onChange={(e: any) => videoShowHideStatus('is_participant_video', e)} />
                  <span > {!getData.meetingDetail.is_participant_video ? 'OFF' : 'ON'}</span>
                  <label >(Participants)</label>
                </div>
                <p className={styles.offtoglebtm}>Initially, Participants video in turned OFF</p>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} ${styles.marBtmmed}`} >
            <div className={styles.checkwaitingroom} onClick={() => updateMeetingDetail('is_participant_waiting_room', !getData.meetingDetail.is_participant_waiting_room)}>
              <div className={styles.lftcheckconsec} >
                <URCheckBox checked={getData.meetingDetail.is_participant_waiting_room}
                  onChange={(e: any) => waitingRoomOnchange('is_participant_waiting_room', e)}></URCheckBox>
                <span className={styles.waitxtlft}>Waiting Room</span>
              </div>
              <p className={styles.WaitingTxt}>Only participants admitted by the host can join the meeting</p>
            </div>
          </div>
          <div className={styles.moredetailstxt} onClick={moreOptionTrigger}>
            <h4>More Details <span className={getData.isMoreDetail ? "icon_uparrow" : "icon_downarrow2"}
            ></span></h4>
          </div>

          {getData.isMoreDetail &&
            <>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec} onClick={() => updateMeetingDetail('is_record_meeting', !getData.meetingDetail.is_record_meeting)}>
                    <URCheckBox checked={getData.meetingDetail.is_record_meeting}
                      onChange={(e: any) => meetingDetailStore('is_record_meeting', e)}></URCheckBox>
                    <span className={styles.waitxtlft}>Automatically record my meeting in (UR Cloud)</span>
                  </div>
                  <p className={styles.WaitingTxt}>50% Consumed, We have scope to upsell the storage add-on here.</p>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec} onClick={() => updateMeetingDetail('is_participant_join_bef_host', !getData.meetingDetail.is_participant_join_bef_host)}>
                    <URCheckBox checked={getData.meetingDetail.is_participant_join_bef_host}
                      onChange={(e: any) => waitingRoomOnchange('is_participant_join_bef_host', e)}></URCheckBox>
                    <span className={styles.waitxtlft}>Allow Participants join before host enters</span>
                  </div>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec} onClick={() => updateMeetingDetail('is_participant_invite_guest', !getData.meetingDetail.is_participant_invite_guest)}>
                    <URCheckBox checked={getData.meetingDetail.is_participant_invite_guest}
                      onChange={(e: any) => meetingDetailStore('is_participant_invite_guest', e)}></URCheckBox>
                    <span className={styles.waitxtlft}>Allow participants to invite guests</span>
                  </div>
                </div>
              </div>

              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec} onClick={() => updateMeetingDetail('is_participant_mute_entry', !getData.meetingDetail.is_participant_mute_entry)}>
                    <URCheckBox checked={getData.meetingDetail.is_participant_mute_entry}
                      onChange={(e: any) => meetingDetailStore('is_participant_mute_entry', e)}></URCheckBox>
                    <span className={styles.waitxtlft}>Mute participants audio upon entry</span>
                  </div>
                </div>
              </div>

              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec}>
                    <URCheckBox className="checkboxborder" checked={getData.is_speaking_lang}
                      onChange={(e: any) => outsideMeetingDetail('is_speaking_lang', e)} ></URCheckBox>
                    <span className={styles.waitxtlft} onClick={() => updateStatus('is_speaking_lang', !getData.is_speaking_lang)}>Meeting common speaking language.</span>
                  </div>
                </div>

                {getData.is_speaking_lang &&
                  <div className={styles.meetlngspeach}>
                    <div className={styles.shareSelect}>
                      <Dropdown overlay={outPutLangSelection} placement="bottomRight" trigger={['click']}
                        onVisibleChange={handle_Spec_VisibleChange}
                        visible={getData.isSpeakView}
                        overlayClassName='customdrpBox'
                        className="cusBoxDrp">
                        <div className={styles.langSelSec}>
                          <span>{getData.ast_default_Spe_Opt}</span>
                          <span className="icon_downarrow2" onClick={() => handle_Spec_VisibleChange(true)}></span>
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                }

              </div>

              <div className={`${alternateHostBtn ? `${styles.formGroup} ${styles.marBtmmax} disabledIcon` :`${styles.formGroup} ${styles.marBtmmax}`}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec}>
                    <URCheckBox className="checkboxborder" checked={getData.meetingDetail.is_alternate_host}
                      onChange={(e: any) => meetingDetailStore('is_alternate_host', e)} ></URCheckBox>
                    <span className={styles.waitxtlft} onClick={() => updateMeetingDetail('is_alternate_host', !getData.meetingDetail.is_alternate_host)}>Alternative Host</span>
                  </div>
                </div>

                {getData.meetingDetail.is_alternate_host &&
                  <div className={styles.meetlngspeach}>
                    {/* <UserInputwithImage alternativeHost={alternateHostDetail}></UserInputwithImage> */}
                    <SingleParticipantList alternativeHost={alternateHostDetail} participantSipDetails={getData.participantSipDetails}></SingleParticipantList>
                  </div>
                }
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={`${styles.checkwaitingroom} ${styles.anycheckconsectop}`}>
                  <div className={styles.lftcheckconsec} >
                    <URCheckBox checked={getData.meetingDetail.requireAuthentication}
                      onChange={(e: any) => meetingDetailStore('requireAuthentication', e)} ></URCheckBox>
                    <span className={styles.waitxtlft} onClick={() => updateMeetingDetail('requireAuthentication', !getData.meetingDetail.requireAuthentication)}>Require Authentication to join</span>

                  </div>
                  {/*  <div className={styles.lftcheckconsec}>
                                     </div> */}

                  <div className={`${styles.shareSelect} ${styles.anyrequstjoin}`}>
                    <Dropdown overlay={UserJoinMenu} placement="bottomRight" trigger={['click']}
                      overlayClassName='customdrpBox'
                      className="cusBoxDrp" >
                      <div className={`${styles.langSelSec} ${styles.every}`}>
                        <span>{getData.meetingDetail.authenticationJoin}</span>
                        <span className="icon_downarrow2"></span>
                      </div>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec}>
                    <URCheckBox checked={getData.meetingDetail.restrictScreenShare}
                      onChange={(e: any) => meetingDetailStore('restrictScreenShare', e)} ></URCheckBox>
                    <span className={styles.waitxtlft} onClick={() => updateMeetingDetail('restrictScreenShare', !getData.meetingDetail.restrictScreenShare)}>Only Host & Co-Host can share screen</span>
                  </div>
                </div>
              </div>

              <FileUpload_MeetingCreation files={fileOnchange} />

              {/* <div className={styles.formGroup}>
                <div className={styles.fileAttchconsec}>
                  <div className={styles.fileAttachList}>
                    <div className={styles.filesImage}><img src={iconxls} alt="filename" /></div>
                    <div className={styles.filesDetails} >
                      <span className={styles.fileName}>Audio_transcribe</span>
                      <span className={styles.fileDt}>4 MB Excel</span>
                    </div>
                    <div onClick={showModal}><span className={`icon_zoom2 ${styles.icnseachbg}`}></span></div>
                    <div className={styles.hoverClick}>
                      <Tooltip placement="top" title={'Remove File'}>
                        <span className="icon_close"></span>
                      </Tooltip>
                    </div>
                    <div className={styles.loadingIcon}>
                      <object data={file_loader} type="image/svg+xml">Loading...</object>
                    </div>
                  </div>
                  <div className={styles.fileAttachList}>
                    <div className={styles.filesImage}><img src={iconword} alt="filename" /></div>
                    <div className={styles.filesDetails}>
                      <span className={styles.fileName}>Audio_transcribe</span>
                      <span className={styles.fileDt}>4 MB Excel</span>
                    </div>
                    <div className={styles.hoverClick}>
                      <Tooltip placement="top" title={'Remove File'} overlayClassName="tooltipCenter">
                        <span className="icon_close"></span>
                      </Tooltip>
                    </div>
                  </div>
            
                </div>
                <div className={styles.attachfilecon}>
                  <div className={styles.attachconsec}>
                    <Upload>
                      <span className={`icon_Newdoc ${styles.plueiconcenter}`}></span>
                      <span className={styles.editUploadText}>Attached Document</span>
                    </Upload>
                  </div>
                </div>
              </div> */}

            </>
          }
          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.checkwaitingroom}>
              <div className={styles.lftcheckconsec} >
                <URCheckBox className="checkboxborder" checked={getData.meetingDetail.save_template}
                  onChange={(e: any) => meetingDetailStore('save_template', e)} ></URCheckBox>
                <span className={styles.waitxtlft} onClick={() => updateMeetingDetail('save_template', !getData.meetingDetail.save_template)}>Save This As A Template</span>
                <div className={`${styles.footerBtn} ${styles.scheduleButton}`}>
                  <URButton className='urButton buttonWhite mr8' onClick={cancelMeeting} name="Cancel"></URButton>
                  <URButton className={`urButton buttonBlue ${getData.buttonEnableStatus ? 'disabled' : ''}`} onClick={createMeeting} name="Schedule"></URButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <AddParticipant participantDetail={participantDetail} participantsInfo={getData.alternateHostDetails} /> */}
      <Modal title="Exit Schedule Meeting"
        centered
        visible={getData.isCancelMeetingModalVisible}
        onOk={cancelMeetingConfirm}
        onCancel={closeCancelMeetingModal}
        cancelText="No"
        okText="Yes"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to exit without saving the changes you made to the Meeting Schedule?
      </Modal>
      {/* <Modal title="Object module.pdf"
        centered
        visible={isModalVisible}
        onCancel={cancelMeeting}
        className="DocumentcustomPopup">
        <div className="chatNoteImgContent">
          <img src={demo3} alt="" />
        </div>
      </Modal> */}
    </>
  );
};